const MD5 = require("js-md5");
import axios from "axios";
// 从容器获取地理位置
async function getLocation() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(false);
    }, 3000);
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      DXLC_JSSDK("getLocation", {}, (result) => {
        let res = JSON.parse(result);
        resolve(res);
      });
    } else if (isIos) {
      DXLC_JSSDK(
        "getLocation",
        {},
        (success) => {
          resolve(success);
        },
        (err) => {
          resolve(false);
        }
      );
    }
  });
}

async function getLocationFromWechatApp() {
  return new Promise((resolve, reject) => {
    // 5秒后自动掐断
    setTimeout(() => {
      resolve(false);
    }, 5000);
    wx.getLocation({
      type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
        var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
        resolve({ lng: longitude, lat: latitude });
      },
    });
  });
}

// 根据百度地图SK计算SN
function calcSN(queryStr, SK) {
  let encodeStr = encodeURIComponent(queryStr);
  let rawStr = encodeStr + SK;
  let SN = MD5(rawStr);
  return SN;
}

// 将native传过来的gps坐标转换成百度坐标
async function changeGPSLocation(lng, lat) {
  let queryStr = `/geoconv/v1/?coords=${lng},${lat}&from=1&to=5&ak=${process.env.VUE_APP_BAIDU_AK_SERVER}`;
  let SN = calcSN(queryStr, process.env.VUE_APP_BAIDU_SK_SERVER);
  // this.loading = true;
  let result = await axios
    .get(`./baidu${queryStr}&sn=${SN}`)
    .then((res) => {
      // this.loading = false;
      if (res.status == 200) {
        // 成功搜索到规划路线
        return res.data.result[0];
      }
    })
    .catch((err) => {
      console.log(err);
      // this.loading = false;
      return false;
    });
  return result;
}

// 将中文地址位置转换成百度坐标  地理编码
async function geocoding(address, cityName) {
  let queryStr = `/geocoding/v3/?address=${encodeURIComponent(
    address
  )}&city=${encodeURIComponent(cityName)}&output=json&ak=${
    process.env.VUE_APP_BAIDU_AK_SERVER
  }`;
  let SN = calcSN(queryStr, process.env.VUE_APP_BAIDU_SK_SERVER);
  let result = await axios
    .get(`./baidu${queryStr}&sn=${SN}`)
    .then((res) => {
      // this.loading = false;
      if (res.status == 200) {
        // 成功搜索到规划路线
        return res.data.result;
      }
    })
    .catch((err) => {
      console.log(err);
      // this.loading = false;
      return false;
    });
  return result;
}

// 逆地理编码  检测传入的坐标的城市编码跟预期code是否一致
async function getNameByLocation(lng, lat, code) {
  let queryStr = `/reverse_geocoding/v3/?ak=${process.env.VUE_APP_BAIDU_AK_SERVER}&output=json&extensions_poi=1&location=${lat},${lng}`;
  let SN = calcSN(queryStr, process.env.VUE_APP_BAIDU_SK_SERVER);
  let result = await axios
    .get(`./baidu${queryStr}&sn=${SN}`)
    .then((res) => {
      console.log(res);
      if (res.status == 200) {
        // 305为柳州市
        if (res.data.result.cityCode == code) {
          return res.data.result.pois[0].name;
        } else {
          return false;
        }
      } else {
        return false;
      }
    })
    .catch((err) => {
      console.log(err);
      return false;
    });
  return result;
}

export {
  getLocation,
  getLocationFromWechatApp,
  changeGPSLocation,
  geocoding,
  getNameByLocation,
};
